export class PMOrder {
  public constructor(
    public orderNumber: string,
    public equipmentNumber: string,
    public shortDescription: string,
    public orderType: string,
    public orderTypeDescription: string,
    public maintenancePlanningPlant: string,
    public plannerGroup: string,
    public plannerGroupName: string,
    public priority: string,
    public priorityDescription: string,
    public maintenanceProcessingPhase: string,
    public notificationNumber: string,
    public objectNumber: string,
    public systemStatus: string,
    public longText: string,
    public changeTime: string,
    public changeBy: string,
    public slackdays?: number,
    public basicFinishDate?: Date,
    public basicStartDate?: Date,
    public changeDate?: Date
  ) {}
}
